export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_API_KEY as string | undefined;

/** Studio style used for the backend static location images. */
export const MAPBOX_STYLE_PATH = 'carvia-it/cljpxbxo800yx01qy4j0zbwdw';
